import { mount } from "@vue/test-utils";
import ChangeAddress from "@/components/core/modals/ChangeAddress";

describe("ChangeAddress component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(ChangeAddress, {
      propsData: {
        value: {},
        show: false,
        otroDomicilio: false
      }
    });
  });

  it("Renders del component  ChangeAddress", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
